"use strict";

import angular from "angular";
import companiesContactsTableSkeletonTemplate from "./companies-contacts/companies-contacts-table-skeleton.html";

angular.module("nucont.accounting.contactsManagment").run([
    "$templateCache",
    ($templateCache) => {
        $templateCache.put(
            "companiesContactsTableSkeleton.html",
            companiesContactsTableSkeletonTemplate
        );
    }
]);
